import React from 'react';
import { BatteryWarningIcon, BrainIcon, ActivityIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="bg-gray-900 text-gray-300 py-20 md:py-28 px-4 border-t border-gray-800" data-id="element-156">
      <div className="max-w-4xl mx-auto" data-id="element-157">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-10 text-center leading-tight" data-id="element-158">
          The "Hidden" Reason You're Tired, Foggy, and Losing Your Edge...
        </h2>

        <div className="prose prose-lg prose-invert max-w-none" data-id="element-159">
          <p className="text-xl leading-relaxed mb-8" data-id="element-160">
            If you are a man over 40, you've likely noticed it. The 3:00 PM
            "crash." The soft midsection that won't go away no matter how much
            you diet. The "brain fog" that makes you feel 10 years older than
            your younger competitors at work.
          </p>

          <div className="bg-gray-800/50 border-l-4 border-red-500 p-6 my-10 rounded-r-lg" data-id="element-161">
            <p className="text-2xl font-semibold text-white m-0" data-id="element-162">
              It isn't "aging." It's a Hormonal Shutdown.
            </p>
          </div>

          <p className="text-xl leading-relaxed mb-8" data-id="element-163">
            Modern stress, blue light, and processed "health foods" have tanked
            the average man's{' '}
            <span className="text-amber-400 font-bold bg-amber-500/10 px-2 py-1 rounded" data-id="element-164">
              testosterone by 25% since the 80s
            </span>
            .
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 my-12" data-id="element-165">
            <div className="bg-gray-800 border border-gray-700 p-6 rounded-xl flex flex-col items-center text-center" data-id="element-166">
              <BatteryWarningIcon className="w-10 h-10 text-red-500 mb-4" data-id="element-167" />
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-168">
                10% Battery Charge
              </h3>
              <p className="text-sm text-gray-400" data-id="element-169">
                You are trying to lead your company and your family on empty.
              </p>
            </div>
            <div className="bg-gray-800 border border-gray-700 p-6 rounded-xl flex flex-col items-center text-center" data-id="element-170">
              <BrainIcon className="w-10 h-10 text-gray-500 mb-4" data-id="element-171" />
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-172">
                Severe Brain Fog
              </h3>
              <p className="text-sm text-gray-400" data-id="element-173">
                Losing the sharp, quick-witted edge that built your career.
              </p>
            </div>
            <div className="bg-gray-800 border border-gray-700 p-6 rounded-xl flex flex-col items-center text-center" data-id="element-174">
              <ActivityIcon className="w-10 h-10 text-amber-500 mb-4" data-id="element-175" />
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-176">
                The "Dad Bod"
              </h3>
              <p className="text-sm text-gray-400" data-id="element-177">
                Stubborn cortisol belly fat that refuses to burn off.
              </p>
            </div>
          </div>

          <p className="text-3xl font-bold text-amber-500 text-center mt-12" data-id="element-178">
            This ends today.
          </p>
        </div>
      </div>
    </section>;
}